import { AfterResponseMiddleware, FetchResponse } from '../types';

export class AuthenticationError extends Error {
  constructor(public readonly response: FetchResponse) {
    super();
  }
}

export const authenticationError: AfterResponseMiddleware = res => {
  if (res.status === 401) {
    throw new AuthenticationError(res);
  }
  return res;
};
